import { useState } from "react";
import { api } from "../lib/api";
import { KeyRound, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function ForceChangePasswordModal({ onDone }) {
  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPwd.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (newPwd !== confirmPwd) return toast.error("Konfirmasi password tidak cocok");
    if (currentPwd === newPwd) return toast.error("Password baru harus berbeda dari password lama");
    setSaving(true);
    try {
      await api.post("/auth/first-login-change-password", {
        current_password: currentPwd, new_password: newPwd,
      });
      toast.success("Password berhasil diubah. Selamat datang!");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal ubah password");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm grid place-items-center p-4"
      data-testid="force-change-password-modal">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
        <div className="bg-gradient-to-r from-amber-600 to-orange-500 text-white px-5 py-4 flex items-center gap-2 rounded-t-2xl">
          <AlertTriangle className="w-5 h-5" />
          <div>
            <h3 className="font-display font-semibold text-sm">Wajib Ganti Password</h3>
            <p className="text-[11px] text-amber-50">Untuk keamanan, ganti password default sebelum melanjutkan.</p>
          </div>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-[11px] text-amber-800">
            <KeyRound className="w-3.5 h-3.5 inline mb-0.5 mr-1" />
            Anda login memakai password default (6 digit terakhir NIK). Ganti sekarang &mdash; tidak bisa akses menu lain sampai selesai.
          </div>
          <label className="block">
            <span className="text-xs font-medium text-slate-600">Password Saat Ini (default)</span>
            <input type="password" required value={currentPwd} onChange={e => setCurrentPwd(e.target.value)}
              data-testid="input-current-pwd" autoFocus
              className="mt-1 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" />
          </label>
          <label className="block">
            <span className="text-xs font-medium text-slate-600">Password Baru (min 6 karakter)</span>
            <input type="password" required value={newPwd} onChange={e => setNewPwd(e.target.value)}
              data-testid="input-new-pwd"
              className="mt-1 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" />
          </label>
          <label className="block">
            <span className="text-xs font-medium text-slate-600">Konfirmasi Password Baru</span>
            <input type="password" required value={confirmPwd} onChange={e => setConfirmPwd(e.target.value)}
              data-testid="input-confirm-pwd"
              className="mt-1 w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" />
          </label>
          <button type="submit" disabled={saving} data-testid="btn-submit-first-pwd"
            className="w-full h-11 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold disabled:opacity-50">
            {saving ? "Menyimpan..." : "Ganti Password &amp; Lanjut"}
          </button>
        </form>
      </div>
    </div>
  );
}
